/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  BigNumberish,
  Overrides,
} from "ethers"
import type { Provider, TransactionRequest } from "@ethersproject/providers"
import type { PromiseOrValue } from "./common"
import type { ParagraphCoinFactory, ParagraphCoinFactoryInterface } from "./"

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_paragraphTreasury",
        type: "address",
      },
      {
        internalType: "address",
        name: "_airlock",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "_paragraphBps",
        type: "uint16",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "successful",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "failed",
        type: "uint256",
      },
    ],
    name: "BatchCollectionCompleted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "caller",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "writerAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "paragraphAmount",
        type: "uint256",
      },
    ],
    name: "FeesDistributed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "writer",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "pool",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "governance",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "timelock",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "migrationPool",
        type: "address",
      },
    ],
    name: "PoolCreated",
    type: "event",
  },
  {
    inputs: [],
    name: "BPS_DENOM",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "airlock",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address",
      },
    ],
    name: "assetToWriter",
    outputs: [
      {
        internalType: "address",
        name: "writer",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "assets",
        type: "address[]",
      },
      {
        internalType: "address[]",
        name: "tokens",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
    ],
    name: "batchCollectFees",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "collectFees",
    outputs: [
      {
        internalType: "uint256",
        name: "writerAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "paragraphAmount",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "writer",
        type: "address",
      },
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "from",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "to",
        type: "uint256",
      },
    ],
    name: "collectWriterFees",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "writer",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "initialSupply",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "numTokensToSell",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "numeraire",
            type: "address",
          },
          {
            internalType: "address",
            name: "tokenFactory",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "tokenFactoryData",
            type: "bytes",
          },
          {
            internalType: "address",
            name: "governanceFactory",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "governanceFactoryData",
            type: "bytes",
          },
          {
            internalType: "address",
            name: "poolInitializer",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "poolInitializerData",
            type: "bytes",
          },
          {
            internalType: "address",
            name: "liquidityMigrator",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "liquidityMigratorData",
            type: "bytes",
          },
          {
            internalType: "address",
            name: "integrator",
            type: "address",
          },
          {
            internalType: "bytes32",
            name: "salt",
            type: "bytes32",
          },
        ],
        internalType: "struct IAirlock.CreateParams",
        name: "createData",
        type: "tuple",
      },
    ],
    name: "createPool",
    outputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "pool",
        type: "address",
      },
      {
        internalType: "address",
        name: "governance",
        type: "address",
      },
      {
        internalType: "address",
        name: "timelock",
        type: "address",
      },
      {
        internalType: "address",
        name: "migrationPool",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "writer",
        type: "address",
      },
    ],
    name: "getWriterAssets",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "writer",
        type: "address",
      },
      {
        internalType: "address[]",
        name: "tokens",
        type: "address[]",
      },
    ],
    name: "getWriterFeeSummary",
    outputs: [
      {
        internalType: "uint256",
        name: "totalCollected",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "totalUncollected",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "totalEarned",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "writer",
        type: "address",
      },
      {
        internalType: "address[]",
        name: "tokens",
        type: "address[]",
      },
    ],
    name: "getWriterUncollectedFees",
    outputs: [
      {
        internalType: "address[]",
        name: "assets",
        type: "address[]",
      },
      {
        internalType: "address[]",
        name: "tokenAddresses",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "uncollectedAmounts",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "totalUncollected",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "writer",
        type: "address",
      },
      {
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "getWriterUncollectedFeesForAsset",
    outputs: [
      {
        internalType: "uint256",
        name: "uncollectedAmount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "paragraphBps",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "paragraphFeesCollected",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "paragraphTreasury",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "totalFeesCollected",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "writerBps",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "writerFeesCollected",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
] as const

const _bytecode =
  "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"

type ParagraphCoinFactoryConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>

const isSuperArgs = (
  xs: ParagraphCoinFactoryConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1

export class ParagraphCoinFactory__factory extends ContractFactory {
  constructor(...args: ParagraphCoinFactoryConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args)
    } else {
      super(_abi, _bytecode, args[0])
    }
  }

  override deploy(
    _paragraphTreasury: PromiseOrValue<string>,
    _airlock: PromiseOrValue<string>,
    _paragraphBps: PromiseOrValue<BigNumberish>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<ParagraphCoinFactory> {
    return super.deploy(
      _paragraphTreasury,
      _airlock,
      _paragraphBps,
      overrides || {}
    ) as Promise<ParagraphCoinFactory>
  }
  override getDeployTransaction(
    _paragraphTreasury: PromiseOrValue<string>,
    _airlock: PromiseOrValue<string>,
    _paragraphBps: PromiseOrValue<BigNumberish>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _paragraphTreasury,
      _airlock,
      _paragraphBps,
      overrides || {}
    )
  }
  override attach(address: string): ParagraphCoinFactory {
    return super.attach(address) as ParagraphCoinFactory
  }
  override connect(signer: Signer): ParagraphCoinFactory__factory {
    return super.connect(signer) as ParagraphCoinFactory__factory
  }

  static readonly bytecode = _bytecode
  static readonly abi = _abi
  static createInterface(): ParagraphCoinFactoryInterface {
    return new utils.Interface(_abi) as ParagraphCoinFactoryInterface
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ParagraphCoinFactory {
    return new Contract(address, _abi, signerOrProvider) as ParagraphCoinFactory
  }
}
